import React, { useEffect, useState } from "react";
import "./Header.scss";
import { Link, NavLink } from "react-router-dom";
import { logo } from "assets/images";
import { dropdownIcon, locationColorIcon, locationIcon, locationSearchIcon } from "assets/icons";
import { GoArrowUpRight } from "react-icons/go";
import NotificationDropDown from "./notification/NotificationDropDown";
import ProfileDropdown from "./profile/ProfileDropdown";
import { failMessage } from "utils/toastMessage";
import { useDispatch, useSelector } from "react-redux";
import { FaBarsStaggered } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import { mySiteApi } from "services/mySites";
import { setSelectedSite } from "redux-toolkit/slices/selectedSiteSlice";
import { fetchUserProfile } from "redux-toolkit/slices/userProfileSlice";
import { Dropdown } from "react-bootstrap";


const Header = () => {
  const dispatch = useDispatch();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [siteList, setSiteList] = useState([])
  const selectedSite = useSelector((state) => state.selectedSite.selectedSite);
  // console.log({ selectedSite,siteList})

  //------when-refresh--there-set-the-profile-details-------------
  useEffect(() => {
    if (selectedSite?._id) {
      dispatch(fetchUserProfile(selectedSite?._id));
    }
  }, [dispatch, selectedSite?._id]);
  //----------handle-change-data------------
  // const handleChange = (e) => {
  //   try {
  //     const selected = JSON.parse(e.target.value);
  //     dispatch(setSelectedSite(selected));
  //     console.log("Selected Site:", selected);
  //   } catch (error) {
  //     console.error("Invalid JSON in select value", error);
  //   }
  // };
  const handleSiteData = (data) => {
    dispatch(setSelectedSite(data))
  }
  //--------site-listing--------------
  useEffect(() => {
    const mySiteList = async () => {
      try {
        const res = await mySiteApi()
        if (res?.status === 200) {
          const data = res?.data?.data
          setSiteList(data || [])
          if (data.length > 0 && !selectedSite) {
            dispatch(setSelectedSite(data[0]));
          }
        } else {
          failMessage(res)
        }
      } catch (e) {
        console.log('error', e?.message)
      }
    }
    mySiteList()
  }, [dispatch]);
  //--------if-not-token-then-navigate------------
  // useEffect(() => {
  //   if (!getToken()) {
  //     navigate('/')
  //     // failMessage('Please login')
  //   }
  // }, [navigate])

  useEffect(() => {
    document.body.classList.toggle("showMenu", mobileMenu);
  }, [mobileMenu]);

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="logo">
            <Link to="/dashboard">
              <img src={logo} alt="" />
            </Link>
            <div className="location_button">
              {/* <Select onChange={handleChange} value={JSON.stringify(selectedSite)}>
                {siteList?.map((site) => (
                  <option key={site._id} value={JSON.stringify(site)}>
                    {site.siteName}
                  </option>
                ))}
              </Select> */}
              <Dropdown className="custom_dropdown">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <img src={locationSearchIcon} alt="" className="icon" />
                  <p>
                    <span>{selectedSite?.siteName}</span>
                    <small>{selectedSite?.projectCity} {selectedSite?.projectState}</small>
                  </p>
                  <img src={dropdownIcon} alt="" className="dropdown_icon" />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {siteList?.map((site) => (
                    <Dropdown.Item
                      as="button"
                      key={site._id}
                      onClick={() => handleSiteData(site)}
                    >
                      <img src={locationColorIcon} alt="" className="icon" />
                      <p>
                        <b>{site.siteName}</b>
                        <span>{site?.projectCity} {site?.projectState}</span>
                      </p>

                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <nav>
            <ul onClick={() => setMobileMenu(false)}>
              <li>
                <NavLink to="/dashboard">Dashboard</NavLink>
              </li>
              <li>
                <NavLink to="/report">Reports</NavLink>
              </li>
              <li>
                <NavLink to="/bills">Bills</NavLink>
              </li>
            </ul>
          </nav>
          <div className="button_section">
            {/* <Link to="https://www.voltenergy.in/" className="about_button">
              Know More About Us <GoArrowUpRight />
            </Link> */}
            <a href="https://www.voltenergy.in/" target="_blank" rel="noopener noreferrer" className="about_button">
              Know More About Us <GoArrowUpRight />
            </a>

            {/* Notification */}
            <NotificationDropDown />

            {/* Profile */}
            <ProfileDropdown />
            <button
              type="button"
              className="menu_button"
              onClick={() => setMobileMenu(!mobileMenu)}
            >
              {!mobileMenu ? <FaBarsStaggered /> : <FaTimes />}
            </button>
          </div>
        </div>
      </header>

      <div className="overlay" onClick={() => setMobileMenu(false)}></div>
    </>
  );
};
export default Header;
